import { Quaternion } from "../../math/Quaternion.js";
export class BaseBodyMath {
    // protected cache: OrbitCache = null;
    orbitPeriod = Infinity;
    orbitSize = Infinity;
    minValidDate = -Infinity;
    maxValidDate = Infinity;
    curvature = 100;
    _rotation;
    _bodyFrame;
    _orbitFrame;
    constructor(rotation, bodyFrame, orbitFrame) {
        this._rotation = rotation;
        this._bodyFrame = bodyFrame;
        this._orbitFrame = orbitFrame;
    }
    OrbitPeriod() {
        return this.orbitPeriod;
    }
    OrbitSize() {
        return this.orbitSize;
    }
    // public virtual double Curvature
    // {
    // 	get{ return curvature; }
    // }
    validate(jd) {
        return this.minValidDate <= jd && jd <= this.maxValidDate;
    }
    // public OrbitCache Cache
    // {
    // 	set{ cache = value; }
    // 	get{ return cache; }
    // }
    //     public set maxValidDate(value: number) {
    //         this._maxValidDate = value;
    //     }
    // 	public double MaxValidDate
    // 	{
    // 		get{ return maxValidDate; }
    // 		set{ maxValidDate = value; }
    // 	}
    // 	public double MinValidDate
    // 	{
    // 		get{ return minValidDate; }
    // 		set{ minValidDate = value; }
    // 	}
    // 	public double RotationPeriod
    // 	{
    // 		get{
    // 			if( _rotation == null )
    // 				return double.PositiveInfinity;
    // 			return _rotation.Period;
    // 		}
    // 	}
    HasRotation() {
        return this._rotation !== null;
    }
    GetSpin(jd) {
        if (this._rotation == null)
            return Quaternion.Identity();
        return this._rotation.computeSpin(jd);
    }
    GetEquatorOrientation(jd) {
        if (this._rotation == null)
            return Quaternion.Identity();
        const equatorOrientation = this._rotation.computeEquatorOrientation(jd);
        if (this._bodyFrame == null)
            return equatorOrientation;
        const bodyFrameOrientation = this._bodyFrame.getOrientation(jd);
        return bodyFrameOrientation.multiply(equatorOrientation);
    }
}
